import {
  highBitstfrzt3uu2jig as highBits,
  lowBits2hhv195ivumfc as lowBits,
  longFromTwoInts3rf7tdb7ckz62 as longFromTwoInts,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  coerceAtMost322komnqp70ag as coerceAtMost,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../ranges/_Ranges.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import {
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
} from '../Char.mjs';
import {
  access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp3w0it47gmcdf0 as access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp,
  get_BYTE_TO_LOWER_CASE_HEX_DIGITS2mrc5tv7dfn1l as get_BYTE_TO_LOWER_CASE_HEX_DIGITS,
} from '../text/HexExtensions.mjs';
import {
  uuidThrowUnexpectedCharacterException3et7vw31qdgo4 as uuidThrowUnexpectedCharacterException,
  Companion_getInstance20qyxpgw1gyvv as Companion_getInstance,
} from './Uuid.mjs';
import { toByte4i43936u611k as toByte } from '../js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function formatBytesInto(_this__u8e3s4, dst, dstOffset, startIndex, endIndex) {
  var dstIndex = dstOffset;
  if (startIndex < 4) {
    dstIndex = formatBytesInto_0(highBits(_this__u8e3s4), dst, dstIndex, startIndex, coerceAtMost(endIndex, 4));
  }
  if (endIndex > 4) {
    formatBytesInto_0(lowBits(_this__u8e3s4), dst, dstIndex, coerceAtLeast(startIndex - 4 | 0, 0), endIndex - 4 | 0);
  }
}
function getLongAt(_this__u8e3s4, index) {
  var tmp0_high = getIntAt(_this__u8e3s4, index);
  var tmp1_low = getIntAt(_this__u8e3s4, index + 4 | 0);
  return longFromTwoInts(tmp1_low, tmp0_high);
}
function uuidParseHexDash(hexDashString) {
  // Inline function 'kotlin.uuid.uuidParseHexDash' call
  var hexDigitExpectedMessage = 'a hexadecimal digit';
  // Inline function 'kotlin.text.parseHexToInt' call
  var result = 0;
  var inductionVariable = 0;
  if (inductionVariable < 8)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = result << 4;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(hexDashString, index);
        var code = Char__toInt_impl_vasixd(this_0);
        if ((code >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code] >= 0) {
          tmp$ret$1 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code];
          break $l$block;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index);
      }
      result = tmp | tmp$ret$1;
    }
     while (inductionVariable < 8);
  var part1 = result;
  // Inline function 'kotlin.uuid.uuidCheckHyphenAt' call
  if (!(charCodeAt(hexDashString, 8) === _Char___init__impl__6a9atx(45))) {
    var errorDescription = "'-' (hyphen)";
    uuidThrowUnexpectedCharacterException(hexDashString, errorDescription, 8);
  }
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_0 = 0;
  var inductionVariable_0 = 9;
  if (inductionVariable_0 < 13)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp_0 = result_0 << 4;
      var tmp$ret$5;
      $l$block_0: {
        // Inline function 'kotlin.code' call
        var this_1 = charCodeAt(hexDashString, index_0);
        var code_0 = Char__toInt_impl_vasixd(this_1);
        if ((code_0 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_0] >= 0) {
          tmp$ret$5 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_0];
          break $l$block_0;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index_0);
      }
      result_0 = tmp_0 | tmp$ret$5;
    }
     while (inductionVariable_0 < 13);
  var part2 = result_0;
  // Inline function 'kotlin.uuid.uuidCheckHyphenAt' call
  if (!(charCodeAt(hexDashString, 13) === _Char___init__impl__6a9atx(45))) {
    var errorDescription_0 = "'-' (hyphen)";
    uuidThrowUnexpectedCharacterException(hexDashString, errorDescription_0, 13);
  }
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_1 = 0;
  var inductionVariable_1 = 14;
  if (inductionVariable_1 < 18)
    do {
      var index_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var tmp_1 = result_1 << 4;
      var tmp$ret$9;
      $l$block_1: {
        // Inline function 'kotlin.code' call
        var this_2 = charCodeAt(hexDashString, index_1);
        var code_1 = Char__toInt_impl_vasixd(this_2);
        if ((code_1 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_1] >= 0) {
          tmp$ret$9 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_1];
          break $l$block_1;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index_1);
      }
      result_1 = tmp_1 | tmp$ret$9;
    }
     while (inductionVariable_1 < 18);
  var part3 = result_1;
  // Inline function 'kotlin.uuid.uuidCheckHyphenAt' call
  if (!(charCodeAt(hexDashString, 18) === _Char___init__impl__6a9atx(45))) {
    var errorDescription_1 = "'-' (hyphen)";
    uuidThrowUnexpectedCharacterException(hexDashString, errorDescription_1, 18);
  }
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_2 = 0;
  var inductionVariable_2 = 19;
  if (inductionVariable_2 < 23)
    do {
      var index_2 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var tmp_2 = result_2 << 4;
      var tmp$ret$13;
      $l$block_2: {
        // Inline function 'kotlin.code' call
        var this_3 = charCodeAt(hexDashString, index_2);
        var code_2 = Char__toInt_impl_vasixd(this_3);
        if ((code_2 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_2] >= 0) {
          tmp$ret$13 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_2];
          break $l$block_2;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index_2);
      }
      result_2 = tmp_2 | tmp$ret$13;
    }
     while (inductionVariable_2 < 23);
  var part4 = result_2;
  // Inline function 'kotlin.uuid.uuidCheckHyphenAt' call
  if (!(charCodeAt(hexDashString, 23) === _Char___init__impl__6a9atx(45))) {
    var errorDescription_2 = "'-' (hyphen)";
    uuidThrowUnexpectedCharacterException(hexDashString, errorDescription_2, 23);
  }
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_3 = 0;
  var inductionVariable_3 = 24;
  if (inductionVariable_3 < 28)
    do {
      var index_3 = inductionVariable_3;
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      var tmp_3 = result_3 << 4;
      var tmp$ret$17;
      $l$block_3: {
        // Inline function 'kotlin.code' call
        var this_4 = charCodeAt(hexDashString, index_3);
        var code_3 = Char__toInt_impl_vasixd(this_4);
        if ((code_3 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_3] >= 0) {
          tmp$ret$17 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_3];
          break $l$block_3;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index_3);
      }
      result_3 = tmp_3 | tmp$ret$17;
    }
     while (inductionVariable_3 < 28);
  var part5a = result_3;
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_4 = 0;
  var inductionVariable_4 = 28;
  if (inductionVariable_4 < 36)
    do {
      var index_4 = inductionVariable_4;
      inductionVariable_4 = inductionVariable_4 + 1 | 0;
      var tmp_4 = result_4 << 4;
      var tmp$ret$20;
      $l$block_4: {
        // Inline function 'kotlin.code' call
        var this_5 = charCodeAt(hexDashString, index_4);
        var code_4 = Char__toInt_impl_vasixd(this_5);
        if ((code_4 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_4] >= 0) {
          tmp$ret$20 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_4];
          break $l$block_4;
        }
        uuidThrowUnexpectedCharacterException(hexDashString, hexDigitExpectedMessage, index_4);
      }
      result_4 = tmp_4 | tmp$ret$20;
    }
     while (inductionVariable_4 < 36);
  var part5b = result_4;
  var tmp0_low = part2 << 16 | part3;
  var msb = longFromTwoInts(tmp0_low, part1);
  var tmp1_high = part4 << 16 | part5a;
  var lsb = longFromTwoInts(part5b, tmp1_high);
  return Companion_getInstance().ri(msb, lsb);
}
function uuidParseHex(hexString) {
  // Inline function 'kotlin.uuid.uuidParseHex' call
  // Inline function 'kotlin.text.parseHexToInt' call
  var result = 0;
  var inductionVariable = 0;
  if (inductionVariable < 8)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = result << 4;
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(hexString, index);
        var code = Char__toInt_impl_vasixd(this_0);
        if ((code >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code] >= 0) {
          tmp$ret$1 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code];
          break $l$block;
        }
        var errorDescription = 'a hexadecimal digit';
        uuidThrowUnexpectedCharacterException(hexString, errorDescription, index);
      }
      result = tmp | tmp$ret$1;
    }
     while (inductionVariable < 8);
  var tmp0_high = result;
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_0 = 0;
  var inductionVariable_0 = 8;
  if (inductionVariable_0 < 16)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp_0 = result_0 << 4;
      var tmp$ret$4;
      $l$block_0: {
        // Inline function 'kotlin.code' call
        var this_1 = charCodeAt(hexString, index_0);
        var code_0 = Char__toInt_impl_vasixd(this_1);
        if ((code_0 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_0] >= 0) {
          tmp$ret$4 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_0];
          break $l$block_0;
        }
        var errorDescription_0 = 'a hexadecimal digit';
        uuidThrowUnexpectedCharacterException(hexString, errorDescription_0, index_0);
      }
      result_0 = tmp_0 | tmp$ret$4;
    }
     while (inductionVariable_0 < 16);
  var tmp1_low = result_0;
  var msb = longFromTwoInts(tmp1_low, tmp0_high);
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_1 = 0;
  var inductionVariable_1 = 16;
  if (inductionVariable_1 < 24)
    do {
      var index_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var tmp_1 = result_1 << 4;
      var tmp$ret$7;
      $l$block_1: {
        // Inline function 'kotlin.code' call
        var this_2 = charCodeAt(hexString, index_1);
        var code_1 = Char__toInt_impl_vasixd(this_2);
        if ((code_1 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_1] >= 0) {
          tmp$ret$7 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_1];
          break $l$block_1;
        }
        var errorDescription_1 = 'a hexadecimal digit';
        uuidThrowUnexpectedCharacterException(hexString, errorDescription_1, index_1);
      }
      result_1 = tmp_1 | tmp$ret$7;
    }
     while (inductionVariable_1 < 24);
  var tmp2_high = result_1;
  // Inline function 'kotlin.text.parseHexToInt' call
  var result_2 = 0;
  var inductionVariable_2 = 24;
  if (inductionVariable_2 < 32)
    do {
      var index_2 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var tmp_2 = result_2 << 4;
      var tmp$ret$10;
      $l$block_2: {
        // Inline function 'kotlin.code' call
        var this_3 = charCodeAt(hexString, index_2);
        var code_2 = Char__toInt_impl_vasixd(this_3);
        if ((code_2 >>> 8 | 0) === 0 && access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_2] >= 0) {
          tmp$ret$10 = access$_get_HEX_DIGITS_TO_DECIMAL_$tHexExtensionsKt_n4nhcp()[code_2];
          break $l$block_2;
        }
        var errorDescription_2 = 'a hexadecimal digit';
        uuidThrowUnexpectedCharacterException(hexString, errorDescription_2, index_2);
      }
      result_2 = tmp_2 | tmp$ret$10;
    }
     while (inductionVariable_2 < 32);
  var tmp3_low = result_2;
  var lsb = longFromTwoInts(tmp3_low, tmp2_high);
  return Companion_getInstance().ri(msb, lsb);
}
function secureRandomBytes(destination) {
  crypto.getRandomValues(destination);
}
function formatBytesInto_0(_this__u8e3s4, dst, dstOffset, startIndex, endIndex) {
  var dstIndex = dstOffset;
  var inductionVariable = 3 - startIndex | 0;
  var last = 4 - endIndex | 0;
  if (last <= inductionVariable)
    do {
      var reversedIndex = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var shift = reversedIndex << 3;
      var byte = _this__u8e3s4 >> shift & 255;
      var byteDigits = get_BYTE_TO_LOWER_CASE_HEX_DIGITS()[byte];
      var _unary__edvuaz = dstIndex;
      dstIndex = _unary__edvuaz + 1 | 0;
      dst[_unary__edvuaz] = toByte(byteDigits >> 8);
      var _unary__edvuaz_0 = dstIndex;
      dstIndex = _unary__edvuaz_0 + 1 | 0;
      dst[_unary__edvuaz_0] = toByte(byteDigits);
    }
     while (!(reversedIndex === last));
  return dstIndex;
}
function getIntAt(_this__u8e3s4, index) {
  return (_this__u8e3s4[index + 0 | 0] & 255) << 24 | (_this__u8e3s4[index + 1 | 0] & 255) << 16 | (_this__u8e3s4[index + 2 | 0] & 255) << 8 | _this__u8e3s4[index + 3 | 0] & 255;
}
//region block: exports
export {
  formatBytesInto as formatBytesInto37zm00l0btni2,
  getLongAt as getLongAt2xo9o2feqbs0,
  secureRandomBytes as secureRandomBytes2zvo6sd7seuw0,
  uuidParseHexDash as uuidParseHexDash18eiuoxladbda,
  uuidParseHex as uuidParseHex3eqot5o6m8iet,
};
//endregion

//# sourceMappingURL=UuidJs.mjs.map
